import { ErrorContext } from "@/_old/error-boundary-context";
import { Component } from "react";
import { ErrorBoundaryProps, ErrorBoundaryState } from "./error-boundary.types";
import { datadogRum } from "@datadog/browser-rum";
import { wobaLogger } from "@/core/config/woba-logger";

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  static contextType = ErrorContext;

  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: undefined };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error(error, errorInfo);

    wobaLogger.error("React Error Boundary caught error", error, {
      type: "react_error_boundary",
      componentStack: errorInfo?.componentStack,
    });

    datadogRum.addError(error, {
      context: {
        componentStack: errorInfo?.componentStack,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      if (!this.props.fallback) {
        return <h1>error</h1>;
      }
      return typeof this.props.fallback === "function"
        ? this.props.fallback(this.state.error)
        : this.props.fallback;
    }

    return this.props.children;
  }
}
